import TargetSection from "./sections/TargetSection";
import CareerProgressionSection from "./sections/CareerProgressionSection";
import KeyAreaSection from "./sections/KeyAreaSection";
import SkillSection from "./sections/SkillSection";
import ProfileSection from "./sections/ProfileSection";
import { useEffect, useState } from "react";
import { getAspirationDetail } from "@endpoints/candidate.service";
import { useDispatch } from "react-redux";
import { setAspirationDetails } from "@store/actions/auth.action";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import ProfileStatusSection from "./sections/ProfileStatusSection";
import MatchInsightSection from "./sections/MatchInsightSection";

const AspirationPage3 = () => {
  const dispatch = useDispatch();

  const [isLoadingDetails, setIsLoadingDetails] = useState(true);

  useEffect(() => {
    const fetchAspirationDetails = async () => {
      try {
        setIsLoadingDetails(true);
        const { success, data } = await getAspirationDetail();
        if (success) {
          dispatch(setAspirationDetails(data));
        }
      } catch (error) {
        console.error("Error fetching aspiration details", error);
      } finally {
        setIsLoadingDetails(false);
      }
    };

    fetchAspirationDetails();
  }, []);

  return (
    <div className="flex flex-col flex-1 rounded-md gap-5 min-h-0 overflow-y-scroll no-scrollbar">
      {isLoadingDetails ? (
        <LoadingAnimation color="#334154" className="m-auto h-7 w-7" />
      ) : (
        <>
          <ProfileSection />
          {/* Main body  */}
          <div className="flex w-full gap-5">
            {/* Cols 1 */}
            <div className="flex flex-col gap-5 flex-1">
              <TargetSection />
              <SkillSection />
              <CareerProgressionSection />
              <KeyAreaSection />
            </div>
            {/* Cols 2 */}
            <div className="flex flex-col gap-5 w-[28%]">
              <ProfileStatusSection />
              <MatchInsightSection />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AspirationPage3;
